module.exports = {
  footerText: 'Copyright Clarity © 2026',
}
